import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { Messages } from "primereact/messages";
import { setSession } from "../../../utilities/Crypto";
import { loginService } from "../../../service/AUTH/LoginService";
import "./portal.css";
import { TokenGenerate } from "../../../service/AUTH/TokenService";
import { addDays, formatDateAPI, formatDateToken } from "../../../utilities/DateUtil";
import FooterIndex from "./FooterIndex";
import { browserName } from "react-device-detect"
import ValidateService from "../../../components/ValidateService/ValidateService";

const Login = () => {

    const messages = useRef(null)
    // const publicIp = require('public-ip')
    const history = useHistory();
    // let messages = {};

    const [sessionId, setSessionId] = useState({
        ipAddress: '',
        sessionId: formatDateAPI(new Date(), false) + "" + Math.floor(1000000000 + Math.random() * 9000000000)
    });

    const [errData, setErrData] = useState(null);
    const [sentData, setSentData] = useState({
        browser: browserName,
        ipAddress: "localhost",
        loginLogout: "I",
        sessionId: formatDateAPI(new Date(), false) + "" + Math.floor(1000000000 + Math.random() * 9000000000),
        userId: "",
        userPassword: "",
    });

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");


    const [accessToken, setAccessToken] = useState("");
    const [sentGenToken, setSentGenToken] = useState({
        apiKeyId: '',
        createBy: username,
        createDt: formatDateToken(new Date(), true),
        desc: "Generate Access Token By Web Application",
        expireDt: formatDateToken(addDays(new Date(), 1), true), //dateToken, // dateToken.setDate(dateToken.getDate() + 1),
        remark: "Generate",
        role: "USER",
    });

    const [passType, setPassType] = useState("hide");

    useEffect(() => {
        setSession("login", null);
        setSession("ipAddress", null);

        (async () => {
            let genSessionId = formatDateAPI(new Date(), false) + "" + Math.floor(1000000000 + Math.random() * 9000000000)
            let ipV4 = window.location.hostname //await publicIp.v4();
            // ipV4 = ((typeof ipV4) ===  "string")?ipV4:"localhost"
            setSentData({
                ...sentData,
                apiKeyId: genSessionId,
                ipAddress: ipV4
            })

            setSessionId({
                sessionId : genSessionId,
                ipAddress: ipV4
            })
        })()

        // console.log('clear session ');
    }, []);

    useEffect(() => {

        if (accessToken !== '') {
            setSession("token", accessToken);
            getLoginService();

        }
    }, [accessToken]);

    const onLoginClick = async () => {
        if (username === "" || password === "") {
            showMessages("กรุณาระบุข้อมูลให้ครบถ้วน");
        } else {
            await onGetSession();
            onTokenGenerate();

        }
    };

    const onGetSession = async () => {
        setSession("login", null);
        setSession("ipAddress", null);

        await (async () => {
            let genSessionId = formatDateAPI(new Date(), false) + "" + Math.floor(1000000000 + Math.random() * 9000000000)
            let ipV4 = window.location.hostname  // await publicIp.v4();
            // ipV4 = ((typeof ipV4) ===  "string")?ipV4:"localhost"
            setSentData({
                ...sentData,
                apiKeyId: genSessionId,
                ipAddress: ipV4
            })

            setSessionId({
                sessionId : genSessionId,
                ipAddress: ipV4
            })
        })()
    }

    const onInputTextChange = (e, type) => {
        if (type === "username") {
            setUsername(e.target.value);
            setSentGenToken({
                ...sentGenToken,
                createBy: e.target.value
            })
        } else {
            setPassword(e.target.value);
        }
    };

    const handleKeyDown = async (e) => {
        if (e.key === "Enter") {
            if (username === "" || password === "") {
                showMessages("กรุณาระบุข้อมูลให้ครบถ้วน");

            } else {
                await onGetSession();
                onTokenGenerate();
            }
        }
    };

    const showMessages = (msg) => {
        messages.current.show({ severity: "error", summary: "เกิดข้อผิดพลาด : ", detail: " " + msg, life: "5000" });
    };

    const getLoginService = async () => {
        let data = {
            browser: sentData.browser,
            ipAddress: sentData.ipAddress,
            loginLogout: "I",
            sessionId: sentData.apiKeyId,
            userId: username,
            userPassword: password,
        };

        await loginService(data, accessToken).then(
            (res) => {
                // console.log('res ',res);
                if (res !== undefined) {
                    let dataRes = res[0];
                    dataRes.userId = data.userId;

                    if (dataRes.statusCode === "C") {
                        setSession("login", { ...dataRes, ...accessToken });
                        setSession("sessionTime", new Date());
                        setSession("ipAddress", sessionId);

                        let path = "";
                        switch (dataRes.userRole) {
                            case "1":
                                path = "100";
                                break;
                            case "2":
                                path = "200";
                                break;
                            case "3":
                                path = "301";
                                break;
                            case "4":
                                path = "300";
                                break;
                            case "8":
                            case "9":
                                path = "350";
                                break;
                            case "A":
                                path = "400";
                                break;
                            default:
                        }


                        window.location = "#/" + path;

                    } else if (dataRes.statusCode === "E") {
                        showMessages(`${dataRes.statusText}`);
                    }
                } else {
                    showMessages(`เกิดข้อผิดพลาด Status Code: ${res.status} ${res.message}`);
                }
            },
            function (err) {
                setErrData(err)
            }
        );
    };

    const onTokenGenerate = async () => {
        await TokenGenerate(sentGenToken).then(
            (res) => {
                if (res != undefined) {

                    // setSession("token", res);
                    setAccessToken(res)

                } else {
                    showMessages(`เกิดข้อผิดพลาด Status Code: ${res.status} ${res.message}`);
                }
            },
            function (err) {
                setErrData(err)
            }
        );
    };

    const onShowPassword = (type) => {
        switch (type) {
            case "show": {
                setPassType("hide");
                break;
            }
            case "hide": {
                setPassType("show");
                break;
            }
        }
    }

    return (
        <>
            <Messages
            ref={messages}
            // ref={(el) => (messages = el)}
            className="show-msg" />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="login-body">
                <div className="login-panel"></div>

                <div className="login-content" style={{ marginTop: "2%" }}>
                    <div className="p-d-flex p-flex-column" style={{ display: "flex", justifyContent: "space-between" }}>
                        <div className="p-col-12 p-md-4" style={{ textAlign: "center" }}>
                            <img src="assets/layout/images/logo/icon.png" style={{ width: "120px" }} />
                        </div>
                    </div>
                    <div className="p-d-flex p-flex-column" style={{ textAlign: "center" }}>
                        <div className="p-col-12 p-md-4">
                            <label style={{ fontSize: '35px', fontWeight: 'bold' }}>ระบบบริหารจัดการงานวางท่อ</label>
                        </div>
                    </div>
                    <div className="p-d-flex p-flex-column" style={{ textAlign: "center" }}>
                        <div className="p-col-12 p-md-4">
                            <label style={{ fontSize: '25px', fontWeight: 'bold' }}>Pipeline Management System : PMS</label>
                        </div>
                    </div>
                    <div className="p-d-flex p-flex-column" style={{ textAlign: "center" }}>
                        <div className="p-col-12 p-md-4">
                            <hr />
                        </div>
                    </div>
                    <div className="p-d-flex p-flex-column" style={{ textAlign: "center" }}>
                        <div className="p-col-12 p-md-4">
                            <label style={{ fontSize: '23px' }}>เข้าสู่ระบบ</label>
                        </div>
                    </div>

                    {/*  */}
                    <div className="p-d-flex p-flex-column">
                        <div className="p-col-12 p-md-4" style={{ display: "flex", justifyContent: "center" }}>
                            <div className="p-inputgroup" style={{ width: "70%" }}>
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-user" style={{ marginRight: "7px" }}></i>
                                </span>
                                <InputText placeholder="ชื่อผู้ใช้" value={username} onChange={(e) => onInputTextChange(e, "username")} onKeyDown={handleKeyDown} />
                            </div>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4" style={{ display: "flex", justifyContent: "center" }}>
                        <div className="p-inputgroup" style={{ width: "70%" }}>
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-unlock" style={{ marginRight: "6px" }}></i>
                            </span>
                            <InputText placeholder="รหัสผ่าน" type={passType === "hide" ? "password" : "text"} value={password} onChange={(e) => onInputTextChange(e, "password")} onKeyDown={handleKeyDown} required toggleMask />
                            <span className="p-inputgroup-addon" onClick={(e) => onShowPassword(passType)}>
                                <i className={passType === "hide" ? "pi pi-eye-slash" : "pi pi-eye"} style={{ marginLeft: "0px" }}></i>
                            </span>
                        </div>
                    </div>
                    <div className="p-col-12 p-md-4" style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            label="เข้าสู่ระบบ"
                            onClick={onLoginClick}
                            icon="pi pi-sign-in"
                            iconPos="right"
                        />
                        <Button
                            label="เปลี่ยนรหัสผ่าน"
                            className="p-button-secondary"
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                history.push("/password");
                            }}
                            icon="pi pi-key"
                            iconPos="right"
                        />
                    </div>
                    <div className="p-col-12 p-md-4" style={{ display: "flex", justifyContent: "center", marginTop: '20px' }}>
                        <FooterIndex />
                    </div>


                    {/* <div className="p-grid crud-demo login-box">
                        <div className="p-col-12 ">
                            <div className="p-grid  p-fluid" style={{ textAlign: "center" }}>
                                <div className="p-col-12 p-md-4">
                                    <img src="assets/layout/images/logo/icon.png" style={{ width: 120, marginBottom: 0, position: "relative" }} alt="PMS" />
                                </div>
                            </div>

                            <div className="p-grid  p-fluid" style={{ textAlign: "center" }}>
                                <div className="p-col-12 p-md-4">
                                    <h3 style={{ fontSize: 30 }}>
                                        <span>
                                            <b>ระบบบริหารจัดการงานวางท่อ</b>
                                        </span>
                                    </h3>
                                    <h3 style={{ marginBottom: "auto", fontSize: 24 }}>เข้าสู่ระบบ</h3>
                                </div>
                            </div>

                            <div className="p-grid  p-fluid">
                                <div className="p-col-12 p-md-2">
                                    <div className="login-input-wrapper" style={{ width: "100%", marginBottom: "5px" }}>
                                        <InputText placeholder="ชื่อผู้ใช้" value={username} onChange={(e) => onInputTextChange(e, "username")} onKeyDown={handleKeyDown} />
                                        <i className="pi pi-user"></i>
                                    </div>
                                </div>
                            </div>

                            <div className="p-grid  p-fluid">
                                <div className="p-col-12 p-md-4">
                                    <div className="login-input-wrapper" style={{ width: "100%", marginBottom: "5px" }}>
                                        <InputText placeholder="รหัสผ่าน" type="password" value={password} onChange={(e) => onInputTextChange(e, "password")} onKeyDown={handleKeyDown} />
                                        <i className="pi pi-unlock"></i>
                                    </div>
                                </div>
                            </div>

                            <div className="p-grid  p-fluid">
                                <div className="p-col-12 p-md-2">
                                    <Button
                                        label="เข้าสู่ระบบ"
                                        className="login-btn-md"
                                        style={{ minWidth: 0 }}
                                        //style={{float:'right'}}
                                        onClick={onLoginClick}
                                        icon="pi pi-sign-in"
                                        iconPos="right"
                                    />
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <Button
                                        label="เปลี่ยนรหัสผ่าน"
                                        className="p-button-secondary login-btn-md"
                                        style={{ minWidth: 0 }}
                                        onClick={() => {
                                            history.push("/password");
                                        }}
                                        icon="pi pi-key"
                                        iconPos="right"
                                    />
                                </div>
                            </div>
                            <FooterIndex />
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    );
};

export default Login;
